import { trigger, transition, query, style, group, animate, AnimationMetadata } from '@angular/animations';

export const oneSideOneAnotherLeftInverted =
[
  query(':enter, :leave', [
    style({
      position: 'absolute',
      top: 0,
      width: '100%'
    })
  ], { optional: true }),
  query(':enter', [
    style({ 'left': '0%' })
  ], { optional: true }),
  query(':leave', [
    style({ 'right': '0%' })
  ], { optional: true }),
  query(':enter', [
    style({ 'left': '100%' })
  ], { optional: true }),
  group([
    query(':leave', [
      animate('600ms ease', style({ 'right': '100%' }))
    ], { optional: true }),
    query(':enter', [
      animate('600ms ease', style({ 'left': true ? 'calc(0% + 314px)' : '0%' }))
    ], { optional: true })
  ])
]

export const oneSideOneAnotherRight =
[
  query(':enter, :leave', [
    style({
      position: 'absolute',
      top: 0,
      width: '100%'
    })
  ], { optional: true }),
  query(':enter', [
    style({ 'right': '0%' })
  ], { optional: true }),
  query(':leave', [
    style({ 'left': '0%' })
  ], { optional: true }),
  query(':enter', [
    style({ 'right': '100%' })
  ], { optional: true }),
  group([
    query(':leave', [
      animate('600ms ease', style({ 'left': '100%' }))
    ], { optional: true }),
    query(':enter', [
      animate('600ms ease', style({ 'right': false ? 'calc(0% + 314px)' : '0%' }))
    ], { optional: true })
  ])
]

export const slideToRight = [
  query(':enter, :leave', [
    style({
      position: 'absolute',
      top: 0,
      right: 0,
      width: '100%'
    })
  ], { optional: true }),
  query(':enter', [
    style({ right: '100%' })
  ], { optional: true }),
  group([
    query(':leave', [
      animate('600ms ease', style({ right: '100%' }))
    ], { optional: true }),
    query(':enter', [
      animate('600ms ease', style({ right: '0%' }))
    ], { optional: true })
  ]),
];

export const sliderAnimation =
  trigger('routeAnimations', [
    transition('UsersComponent => UserFormComponent', oneSideOneAnotherLeftInverted),
    transition('UserFormComponent => UsersComponent', oneSideOneAnotherRight),
    transition('LabelsComponent => LabelsFormComponent', oneSideOneAnotherLeftInverted),
    transition('LabelsFormComponent => LabelsComponent', oneSideOneAnotherRight),
    transition('* => *', slideToRight),
  ]);

function slideTo(direction, opposite = false) {
  const optional = { optional: true };
  const oppositeDirection = direction === 'left' ? 'right' : 'left'
  return [
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        [direction]: 0,
        width: '100%'
      })
    ], optional),
    query(':enter', [
      style({ [direction]: '100%' })
    ], optional),
    group([
      query(':leave', [
        animate('600ms ease', style({ [opposite ? oppositeDirection : direction]: '100%' }))
      ], optional),
      query(':enter', [
        animate('600ms ease', style({ [direction]: '0%' }))
      ], optional)
    ]),
    // Normalize the page style... Might not be necessary

    // Required only if you have child animations on the page
    // query(':leave', animateChild()),
    // query(':enter', animateChild()),
  ];
}

function oneSideOneAnother(direction, toSidebar = false) {
  const optional = { optional: true };
  const oppositeDirection = direction === 'left' ? 'right' : 'left'
  return [
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        width: '100%'
      })
    ], optional),
    query(':enter', [
      style({ [direction]: '0%' })
    ], optional),
    query(':leave', [
      style({ [oppositeDirection]: '0%' })
    ], optional),
    query(':enter', [
      style({ [direction]: '100%' })
    ], optional),
    group([
      query(':leave', [
        animate('600ms ease', style({ [oppositeDirection]: '100%' }))
      ], optional),
      query(':enter', [
        animate('600ms ease', style({ [direction]: toSidebar ? 'calc(0% + 314px)' : '0%' }))
      ], optional)
    ]),
    // Normalize the page style... Might not be necessary

    // Required only if you have child animations on the page
    // query(':leave', animateChild()),
    // query(':enter', animateChild()),
  ];
}

